import { h, createRef } from 'preact';
import Page from 'components/pages/page.js';
import { Link } from 'components/core/link/link.js';
import SimpleVideoPlayer from 'components/shared/simpleVideoPlayer/simpleVideoPlayer';
import HomeEntButtons from 'components/shared/homeEntButtons/homeEntButtons';
import Youtube from 'components/shared/youtube/youtube.js';
import ClosableTrailer from 'components/shared/closableTrailer/closableTrailer';
import OneSheet from 'components/pages/showtimes/oneSheet.js';
import { track } from 'utils/tracking';
import { accessNested, condClass, sortObjectByOrder } from 'utils/utils';
import pure from 'utils/pure';
import s from 'components/pages/homeEnt/homeEnt.sss';
import { marked } from 'marked';
import HTML from 'components/core/html/html';
import Vimeo from 'components/shared/vimeo/vimeo.js';
import Store from 'store/store';
import * as actions from 'store/actions';

export default @pure class HomeEnt extends Page {

	constructor(props) {
		super(props);

		this.renderVideo = this.renderVideo.bind(this);
		this.renderRedirectModal = this.renderRedirectModal.bind(this);
		this.updateTime = this.updateTime.bind(this);
		this.closeModal = this.closeModal.bind(this);

		this.wrapperRef = createRef();
		this.handleClickOutside = this.handleClickOutside.bind(this);
		this.lockScroll = this.lockScroll.bind(this);

		if (typeof window !== 'undefined' && window.location && window.location.search) {
			const { pageData } = this.props;
			const { promotionalRedirection = {} } = pageData;
			const { promotionalRedirectionUrl } = promotionalRedirection;

			this.usingPromoRedirect = !!(location.search.indexOf('promotional_redirect') > -1 && promotionalRedirectionUrl);
		}

		this.state = {
			selectedRegion: '',
			modalOpen: this.usingPromoRedirect,
			initialCount: 0
		};

	}

	componentDidMount() {
		window.addEventListener('pushstate', this.logStateChange);
		window.addEventListener('popstate', this.logStateChange);

		if (this.usingPromoRedirect) {
			window.addEventListener('mousedown', this.handleClickOutside);
			this.startTimer();
		}

		const hash = location.hash.slice(1);

		if (!hash) {
			return;
		}
		this.setState({
			selectedRegion: hash.replace('/', '')
		});

		if (typeof window.firstSessionVisit === 'undefined') {
			window.firstSessionVisit = true;
		} else {
			window.firstSessionVisit = false;
		}
	}//componentDidMount

	componentDidUpdate(prevProps, prevState) {
		if (prevState.count !== this.state.count && this.state.count === 0) {
			this.redirect();
		}
	}

	componentWillUnmount() {
		window.removeEventListener('pushstate', this.logStateChange);
		window.removeEventListener('popstate', this.logStateChange);
		window.removeEventListener('mousedown', this.handleClickOutside);
	}

	renderRegion(regionLinks, key) {
		let link = regionLinks[key];
		let title = link.title;
		let slug = link.slug || '';
		let image = link.src;
		const buttonText = title || key;
		const imageRegionRoot = this.props.appData.urls.roots.imageRegion;
		return (
			<div class={s.regionThumb} onClick={() => this.setSelectedRegion(slug, buttonText)}>
				{image ? <img class={s.image} src={`${imageRegionRoot}/${image}`} /> : null}
				<div class={s.region}>
					{buttonText}
				</div>
			</div>
		);
	}

	getExtraLinks() {
		return;
	}

	renderCta(elem) {
		let copy = accessNested(this.props, 'appData.copy') || {};
		let text = copy[elem.availableFrom] || elem.availableFrom;
		if (!text) {
			return;
		}
		let iconShade = accessNested(this.props, 'activePage.data.logoShade') || accessNested(this.props, 'appData.styling.logoShade') || 'light';
		let iconClass = s.digitalIcon;
		if (elem.distribution === 'physical') {
			iconClass = s.cartIcon;
		}
		return (
			<p class={s.cta + condClass(s[iconShade + 'Icon'])}>
				<span class={iconClass} />
				{text}
			</p>
		);
	}

	renderVideo(video) {
		if (video) {
			const {
				appData,
				client
			} = this.props;

			if (!video.ytVideo) {
				const {
					track,
					enableMobileSound,
					assetName
				} = video;
				const videoRoot = appData.urls.roots.media;

				if (video.vimeoID) {
					return (
						<Vimeo
							maintainAspectRatio
							iframeClass={s.youtubeWrapper}
							class={s.ytWrapper}
							vimeoID={video.vimeoID}
						/>
					);
				} else {
					return (
						<SimpleVideoPlayer
							track={track}
							enableMobileSoundIOS={enableMobileSound}
							key={assetName}
							loop
							src={`${videoRoot}/video/${assetName}`}
							class={s.brandingVideo}
						/>
					);
				}

			} else if (video.ytVideo) {
				return (
					<div class={s.ytWrapper}>
						<Youtube
							client={client}
							activeItem={video}
							maintainAspectRatio={client.deviceSize !== 'desktop'}
							iframeClass={s.youtubeWrapper}
						/>
					</div>
				);
			}
		}
	}

	renderClosableTrailer() {
		const { appData, pageData, client } = this.props;

		if (typeof window !== 'undefined' && window.firstSessionVisit && pageData.closableTrailer) {
			const {
				ytid = '',
				closeText = '',
				overlayText = '',
				src: closingSrc = '',
				vimeoID = '',
				showTT = false
			} = pageData.closableTrailer;

			return (
				<ClosableTrailer
					imgRoot={accessNested(appData, 'urls.roots.imageRegion')}
					ytid={ytid}
					vimeoID={vimeoID}
					closeText={closeText}
					overlayText={overlayText}
					showTT={showTT}
					src={closingSrc}
					client={client}
					activePage={appData.activePage}
				/>
			);
		}
	}

	getFinalUrl() {
		const { pageData } = this.props;
		const { promotionalRedirection = {} } = pageData;
		const { promotionalRedirectionUrl } = promotionalRedirection;

		let destination = promotionalRedirectionUrl;
		if (destination && !/(\/\/.+)(\/.+\..+|\/)$/.test(destination)) {
			destination += '/';
		}
		if (destination && typeof location !== 'undefined') {
			destination += location.search;
		}
		return destination;
	}

	startTimer() {
		const { pageData } = this.props;
		const { promotionalRedirection = {} } = pageData;
		const { promotionalRedirectionTimer } = promotionalRedirection;

		this.setState({
			count: parseInt(promotionalRedirectionTimer) || 5,
			initialCount:  parseInt(promotionalRedirectionTimer)
		});
		this.timer = setInterval(this.updateTime, 1000);
	}

	stopTimer() {
		clearInterval(this.timer);
		this.timer = null;
	}

	updateTime() {
		this.setState({ count: Math.max(this.state.count - 1, 0) });
	}

	redirect() {
		this.stopTimer();
		let destination = this.getFinalUrl();
		if (destination) {
			let promo = '?promotional_redirect';
			location.href = destination.includes(promo) ? destination.replace(promo, '') : destination;
		}
	}

	handleClickOutside(event) {
		if (this.wrapperRef && !this.wrapperRef.current.contains(event.target)) {
			this.closeModal();
		}
	}

	lockScroll(lock) {
		let overflow = lock ? 'hidden' : '';
		document.body.style.overflow = overflow;
		document.documentElement.style.overflow = overflow;
	}

	getDevice(data) {
		const { device, deviceSize } = Store.get().client;

		// On desktop, use desktop assets no matter the size
		if (device === 'desktop') {
			return data.desktop || {};
		}

		switch (deviceSize) {
			case 'mobile':
				return data.mobile || {};
			case 'tablet':
				return data.tablet || {};
			default:
				return data.desktop || {};
		}
	}

	getModalBackground() {
		const { promotionalRedirection } = this.props.pageData;
		const { alt, src } = this.getDevice(promotionalRedirection.backgroundImage);
		return <img class={s.modalBackground} src={src} alt={alt} />;
	}

	getTextImage() {
		const { promotionalRedirection } = this.props.pageData;
		const { alt, src } = this.getDevice(promotionalRedirection.textImage);
		return <img class={s.textImage} src={src} alt={alt} />;
	}

	getModalBtn() {
		const { link } = this.props.pageData.promotionalRedirection;
		if (link) {
			return (
				<Link
					class={s.promoLink}
					role="button"
					href={link.href}
					ariaLabel={link.ariaLabel}
					// pageId={}
					title={link.copy}
					target="_blank"
				>
					{link.copy}
				</Link>
			);
		}
	}

	renderRedirectModal() {
		this.lockScroll(true);

		const { count, initialCount } = this.state;
		const timeLeft = initialCount - count;

		return (
			<div class={s.modalContainer}>
				<div class={s.redirect} ref={this.wrapperRef}>
					{this.getModalBackground()}
					<div
						class={s.closeButton}
						onClick={(e) => {
							e.stopPropagation();
							this.closeModal();
						}}
					/>
					<div class={s.promoWrapper}>
						{this.getTextImage()}
						{this.getModalBtn()}
					</div>
				</div>
				<div class={s.barContainer}>
					<div class={s.progressBar} style={{ transition: `all 1s linear`, transform: `scaleX(${timeLeft / initialCount})` }} />
				</div>
			</div>
		);
	}

	closeModal() {
		this.lockScroll(false);
		window.removeEventListener('mousedown', this.handleClickOutside);

		this.stopTimer();
		this.setState({
			modalOpen: false
		});
	}

	render({ pageData, appData, client, id, sideNavActive }, { selectedRegion }) {
		// const { promotionalRedirection } = appData.options;
		const { modalOpen } = this.state;

		if (typeof window !== 'undefined') {
			if ( this.usingPromoRedirect && modalOpen) {
				return this.renderRedirectModal();
			}
		}

		if (pageData.buttonLayout) {
			return (
				<div class={s.buttonWrapper}>
					{this.renderClosableTrailer()}
					<HomeEntButtons {...this.props} />
					{this.getExtraContent()}
				</div>
			);
		}

		const { copy } = appData;
		const imageRegionRoot = appData.urls.roots.imageRegion;
		const sharedImageRoot = appData.urls.roots.sharedImages;

		let wrapperClass = pageData.fullHomeEnt ? s.fullHomeEntWrapper : s.basicHomeEntWrapper;
		let useTT = pageData.useTT;
		let packShots = pageData.packShots ? sortObjectByOrder(pageData.packShots) : {};
		let region = appData.meta.region.slug;

		let packShotsGroup = (
			<div class={s.packShots}>
				{Object.keys(packShots).map(packshot => {
					let data = packShots[packshot];
					if (!data) return;
					return (
						<div class={s.packShot}>
							<Link href={data.link} target="_blank">
								<img src={data.src} />
								{data.title && <p class={s.packShotText}>{data.title}</p>}
								{data.ctaText && <Link class={s.packShotCta} target="_blank">{copy[data.ctaText]}</Link>}
							</Link>
						</div>
					);
				})}
			</div>
		);

		if (pageData.countrySelector && pageData.regionLinks && !selectedRegion) {

			// filtering by order then resorting to alphabet by title then slug
			let regionLinks = Object.keys(pageData.regionLinks) // [au, gb, us]
				.map(k => pageData.regionLinks[k])
				.filter(e => e)
				.sort((a, b) => {
					if (a.order == b.order) {
						let compareA = a.title || a.slug;
						let compareB = b.title || b.slug;
						return compareA.localeCompare(compareB);
					}
					if (a.order == undefined) return 1;
					if (b.order == undefined) return -1;
					return a.order - b.order;
				});

			let selectorTitle = pageData.countrySelectorTitle;
			if (typeof copy[selectorTitle] === 'string') {
				selectorTitle = copy[selectorTitle];
			}
			return (
				<div class={s.regionWrapper} key="region">
					{this.getExtraContentBefore()}
					<HTML class={s.regionTitle} content={selectorTitle} markdown />
					<div class={s.regions}>
						{Object.keys(regionLinks).map(this.renderRegion.bind(this, regionLinks))}
					</div>
					{this.getExtraContent()}
				</div>
			);
		}

		let digitalGroup;
		if (!pageData.countrySelector || selectedRegion) {
			let linksObj = pageData.countrySelector ? accessNested(pageData.regionLinks, [selectedRegion, 'links'], []) : pageData.links;
			linksObj = sortObjectByOrder(linksObj, (value, key) => {
				if (!value) return;
				return Object.assign({
					id: key
				}, value);
			}).filter(e => e);
			// grabbing the linksTitle from region first then falling back to pageData linksTitle
			let regionData = accessNested(pageData, ['regionLinks', selectedRegion]) || {};
			let linksTitle = regionData.linksTitle || pageData.linksTitle;
			// grabbing the linksDescription from region first then falling back to pageData linksDescription
			let linksDescription = regionData.linksDescription || pageData.linksDescription;
			// adding margin if there are no contents
			let verticalMargin = Object.keys(linksObj).length > 0 ? '' : s.verticalMargin;
			let title = [];
			if (copy[linksTitle]) {
				title.push(
					<h1
						class={s.linksTitle}
						dangerouslySetInnerHTML={{ __html: marked(copy[linksTitle]) }}
					/>
				);
			}
			if (copy[linksDescription]) {
				title.push(
					<h1
						class={s.linksDescription}
						dangerouslySetInnerHTML={{ __html: marked(copy[linksDescription]) }}
					/>
				);
			}

			digitalGroup = (
				<div class={`${s.homeEntLinks} ${verticalMargin}`}>
					{this.getExtraLinks()}
					{title}
					{this.returnToRegions()}
					{this.renderRegionLinks()}
					{linksObj.map(linkElem => {

						let link = linkElem.id;
						let regionFolder = region; // pageData.countrySelector ? this.state.selectedRegion : region;
						let trackIdentification = linkElem.distribution === 'cart' ? 'buy_now_click' : 'vod_click';
						let name = copy[linkElem.name] || linkElem.name;
						let tracking = linkElem.tracking || linkElem.trackId;
						let trackLab = copy[tracking] || tracking || link;

						//construct the link if we haven't been given an absolute one already
						const logoSrc = linkElem.src.indexOf('/') == 0 ? linkElem.src : `${sharedImageRoot}/regions/${regionFolder}/${linkElem.src}`;
						let extraTracking = () => {
							track({ a: trackIdentification + '_' + link });
							Store.emit(actions.HOMEENT_VENDOR_CLICKED, linkElem.link, name, linkElem);
						};

						return (
							<div class={s.link}>
								<Link href={linkElem.link} target="_blank" trackId={trackIdentification} trackLabel={trackLab} extraOnClick={extraTracking}>
									<div class={s.linkGroup}>
										<p class={s.homeEntPackshot}>{linkElem.packShot && <img class={s.homeEntPackshotImage} src={`${imageRegionRoot}/home_ent/${linkElem.packShot}`} />}</p>
										<p class={s.homeEntLogo}><img class={s.homeEntLogoImage} src={logoSrc} /></p>
										<p class={s.homeEntTitle}>{name && <HTML class={s.title} content={name} markdown />}</p>
									</div>
									{this.renderCta(linkElem)}
								</Link>
							</div>
						);
					})}
				</div>
			);
		}

		if (!pageData.fullHomeEnt) {
			return (
				<div class={wrapperClass} key="notfull">
					{useTT && this.getTitleTreatment(copy)}
					{pageData.releaseMessage && <h1 class={s.releaseMessage}>{copy[pageData.releaseMessage]}</h1>}
					{this.renderVideo(pageData.video)}
					{pageData.packShotsFirst && packShotsGroup}
					{digitalGroup}
					{!pageData.packShotsFirst && packShotsGroup}
					{this.getExtraContent()}
				</div>
			);
		}
		let regionData = (selectedRegion && accessNested(pageData, ['regionLinks', selectedRegion])) || {};
		let customPageData = Object.assign({}, pageData, regionData);
		return (
			<div class={wrapperClass} key="full">
				{this.renderClosableTrailer()}
				<OneSheet
					id={id}
					class={s.onesheet}
					pageData={customPageData}
					appData={appData}
					toggleVerticalStory={this.toggleVerticalStory}
					sideNavActive={sideNavActive}
					verticalFullView={false}
					hideable={client.deviceSize === 'mobile'}
					forceClose={false && !!appData.options.showtimesVerticalStory}
					client={client}
					firstDataLoaded
					key="homeEntOnesheet"
				/>
				{this.getExtraContentBefore()}
				{digitalGroup}
				{this.getExtraContent()}
			</div>
		);
	}

	returnToRegions = () => {
		let pageData = this.props.pageData;
		let copy = this.props.appData.copy;
		let backText = pageData.countrySelectorBackTitle;
		if (typeof copy[backText] === 'string') {
			backText = copy[backText];
		}
		if (!backText) backText = 'back to country selector';

		// TODO: for this char: Option ? Copy ?
		backText = '« ' + backText;

		if (!this.props.pageData.countrySelector) {
			return;
		}
		return (
			<div
				class={s.returnToRegions}
				onClick={(e) => {
					e.stopPropagation();
					this.saveHistory('');
					this.setState({ selectedRegion: '' });
				}}
			>
				{backText}
			</div>
		);
	};

	renderRegionLinks = () => {
		let data = this.props.pageData;
		// checking region level first
		let extraLinks = data.regionLinks && this.state.selectedRegion && sortObjectByOrder(data.regionLinks[this.state.selectedRegion].extraLinks);
		// checking pageData level
		if (!extraLinks) {
			extraLinks = data.extraLinks;
		}
		if (!extraLinks) {
			// if there are no extraLinks anywhere to be found
			return;
		}
		return Object.keys(extraLinks).map(link => {
			let { text } = extraLinks[link];
			let href = extraLinks[link].url || false;
			let pageId = extraLinks[link].pageId || false;
			let attrs = {};
			if (href) {
				attrs.href = href;
				attrs.target = '_blank';
			} else if (pageId) {
				attrs.pageId = pageId;
			}
			return (
				<Link {...attrs} class={s.extraLink}>« {text}</Link>
			);
		});
	};

	getTitleTreatment = () => {
		return (
			<img
				ref={e => this.$tt = e}
				alt={this.props.appData.copy.$HOME_TITLE_TREATMENT_SEO}
				class={s.title}
				src={this.props.appData.urls.roots.imageRegion + '/tt.png'}
			/>
		);
	};

	getExtraContent() { }

	getExtraContentBefore() { }

	toggleVerticalStory = (verticalStoryEnabled) => {
		// return;
		let body = document.body;
		if (verticalStoryEnabled) {
			track({ a:'vertical-mobile-banner-enable' });
			body.scrollTop = 0;
			body.style.overflow = 'hidden';
		} else {
			track({ a:'vertical-mobile-close-experience' });
			body.style.overflow = '';
		}
		this.setState({ verticalStoryEnabled });
	};

	setSelectedRegion = (region) => {
		this.saveHistory(region);
		track({ a: 'country-selected', l: region });
		track({ a: `vod${region}-view` });
		this.setState({ selectedRegion: region });
	};

	logStateChange = ({ state }) => {
		if (state) {
			const region = state.selectedRegion;
			this.setState({
				selectedRegion : region
			});
		} else {
			this.setState({
				selectedRegion : ''
			});
		}
	};//logStateChange

	saveHistory = (region) => {
		//const url = label.toLowerCase().replace(/(^\s+|[^a-zA-Z0-9 ]+|\s+$)/g,"").replace(/\s+/g, "-");
		window.history.pushState({
			selectedRegion : region
		}, region, '#' + region);
	};//saveHistory

}
